import { combineReducers, configureStore } from '@reduxjs/toolkit';
import reducers from 'src/redux/slices';
import { baseApiWithCompanyId, retryApi } from 'src/redux/services/baseApi';
import { usersApi } from 'src/redux/services/users';
import { authApi } from 'src/redux/services/auth';
import { receiptApi } from 'src/redux/services/receipt';
import { scoreApi } from 'src/redux/services/score';
import { notificationApi } from 'src/redux/services/notifications';
import { setupListeners } from '@reduxjs/toolkit/query/react';

const rootReducer = combineReducers(reducers);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: { warnAfter: 128 },
    }).concat(
      retryApi.middleware,
      baseApiWithCompanyId.middleware,
      usersApi.middleware,
      authApi.middleware,
      receiptApi.middleware,
      scoreApi.middleware,
      notificationApi.middleware
    ),
});

export type RootState = ReturnType<typeof rootReducer>;

setupListeners(store.dispatch);
